<template>
    <div class="countdown"
         v-bind:class="{red:lastDay}"
         v-html="render"></div>
</template>

<script>
    export default {
        name: 'OfferCounter',
        data: () => {
            return {
                diffTime: 0,
                days: 0,
                lastDay: false,
                hours: 0,
                minutes: 0,
                seconds: 0,
                timerInterval: null
            }
        },
        computed: {
            endTime: function () {
                let date = new Date(this.$attrs.endtime * 1000);
                return date;
            },
            formatHours: function () {
                if (this.hours < 10) {
                    return `0${this.hours}`;
                }
                return this.hours;
            },
            formatMinutes: function () {
                if (this.minutes < 10) {
                    return `0${this.minutes}`;
                }
                return this.minutes;
            },
            formatSeconds: function () {
                if (this.seconds < 10) {
                    return `0${this.seconds}`;
                }
                return this.seconds;
            },
            render: function () {
                let counter = '';
                if (this.days > 1) {
                  counter = `Noch ${this.days} Tage ${this.hours} Stunden`;
                } else if (this.days === 1) {
                    counter = `Noch ${this.days} Tag ${this.hours} Stunden`;
                } else {
                    counter = `Nur noch ${this.formatHours}:${this.formatMinutes}:${this.formatSeconds}`;
                }
                return counter;
            }
        },
        mounted() {
            this.startTimer();
        },
        methods: {
            startTimer: function () {
                let self = this;
                this.timerInterval = setInterval(function () {
                        self.diffTime = Math.floor(Math.abs(new Date(self.$attrs.endtime * 1000) - new Date()) / 1000);
                        if (self.diffTime >= 86400) {
                            self.days = Math.floor(self.diffTime / 86400);
                            self.diffTime = self.diffTime - (self.days * 86400)
                        } else {
                            self.days = 0;
                            self.lastDay = true;
                        }
                        if (self.diffTime >= 3600) {
                            self.hours = Math.floor(self.diffTime / 3600);
                            self.diffTime = self.diffTime - (self.hours * 3600)
                        } else {
                            self.hours = 0;
                        }
                        if (self.diffTime >= 60) {
                            self.minutes = Math.floor(self.diffTime / 60);
                            self.diffTime = self.diffTime - (self.minutes * 60);
                        }
                        self.seconds = Math.floor(self.diffTime);
                    }
                    , 1000);
            }
        }
    }
</script>

<style lang="scss">
</style>